import * as React from 'react';
import { usePortalConnections } from 'vet-bones/utils/portal';

import { usePortalDemoConnection } from 'src/common/hooks/usePortalDemoConnection';

/**
 * Returns a list of portal connections, including the "demo" connection
 */
export const usePortalConnectionsWithDemo = () => {
  const demoConnection = usePortalDemoConnection();
  const portalConnections = usePortalConnections().data;

  return React.useMemo(() => {
    if (portalConnections && demoConnection) {
      return [...portalConnections, demoConnection];
    }
    if (portalConnections) {
      return portalConnections;
    }
    if (demoConnection) {
      return [demoConnection];
    }
    return null;
  }, [portalConnections, demoConnection]);
};
